export default function Placeholder({ title, icon = 'ri-layout-grid-line' }: { title: string; icon?: string }) {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-50 text-primary-500">
        <i className={`${icon} text-3xl`} />
      </div>
      <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950">{title}</h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        Bu bölüm bir sonraki aşamada tamamen işlevsel hale getirilecek. Şu an Genel Bakış ekranını
        inceliyorsunuz.
      </p>
      <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-semibold text-accent-800">
        <i className="ri-information-line" />
        Faz 1 kapsamında demo
      </div>
    </div>
  );
}